import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { filterNilValue } from "@datorama/akita";
import { RouterQuery } from "@datorama/akita-ng-router-store";
import { switchMap, take } from "rxjs";
import { RegisterOwnersDto } from "../../api/nerri/owners/dto/register-owners.dto";
import { AppQuery } from "../../store/app.query";
import { RegisterQuery } from "./store/register.query";
import { RegisterService } from "./store/register.service";

@Component({
    selector: "nerri-register",
    standalone: false,
    templateUrl: "./register.template.html",
    styleUrls: ["./register.style.scss"],
    encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit, OnDestroy {
    protected readonly organisation$ = this.appQuery.organisation$;
    protected readonly loading$ = this.query.selectLoading();
    protected readonly owner$ = this.query.selectOwner();
    protected readonly hasRegistered$ = this.query.selectHasRegistered();
    protected readonly isLoggedIn$ = this.query.selectIsLoggedIn();
    protected readonly hasValidationError$ = this.query.selectHasValidationError();

    constructor(
        private service: RegisterService,
        private query: RegisterQuery,
        private appQuery: AppQuery,
        private routerQuery: RouterQuery
    ) {}

    public ngOnInit(): void {
        this.routerQuery
            .selectParams("uuid")
            .pipe(
                take(1),
                filterNilValue(),
                switchMap(uuid => this.service.validateUuid(uuid))
            )
            .subscribe();
    }

    public ngOnDestroy(): void {
        this.service.reset();
    }

    protected register(dto: Omit<RegisterOwnersDto, "uuid">): void {
        this.service.register(dto).subscribe();
    }

    protected validateCode(code: string): void {
        this.service.validateCode(code).subscribe();
    }
}
